import { render, staticRenderFns } from "./SideNavigationBackArrow.vue?vue&type=template&id=cfb295a0&scoped=true&"
import script from "./SideNavigationBackArrow.vue?vue&type=script&lang=js&"
export * from "./SideNavigationBackArrow.vue?vue&type=script&lang=js&"
import style0 from "./SideNavigationBackArrow.vue?vue&type=style&index=0&id=cfb295a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb295a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
